import React, { useState, useRef, useEffect } from 'react'
import { Fade } from 'react-slideshow-image'
import { Link } from 'react-router-dom'

// import mainMap from '../../../assets/images/maps/world-main.png'
import mainMap from '../../../assets/images/maps/world-main.jpeg'
import backMap from '../../../assets/images/maps/world-back.png'
import arrow from '../../../assets/images/svg_icons/map_arrow.svg'

import { countries } from '../map.markers'
import { getPostitions } from '../utils'
import { getURLByRouteName } from '../../../utils/routes'

const Companies = props => {
  const { texts } = props
    , { map } = props.data
    , [selectView, setSelectView] = useState('operation')

  const onChangeSlide = (type) => {
    const element = document.getElementById('slider-container');
    if (type === 'top' && element) {
      element.scrollTop -= 100;
    } else {
      element.scrollTop += 100;
    }
  }

  return (
    <div className="home__world">
      <div className="home__world-header">
        <h2 className="home__world-sanfer red-color">SANFER</h2>
        <h2 className="home__world-title">{map.title}</h2>
        <div
          className="gray-color"
          dangerouslySetInnerHTML={{
            __html: map.desc,
          }}
        />
      </div>

      <div className="home__world-select-companies">
        {map.companies.map((company, index) => (
          <Link
            key={index}
            to={`${getURLByRouteName("global")}?key=${company.title}`}
          >
            <img
              className="home__world-image"
              src={company.smallLogo}
              alt={company.title}
            />
          </Link>
        ))}
      </div>
      <div className="home__world-select-companies-mobile">
        <div className="slider">
          <img onClick={() => onChangeSlide('top')} id="btn-top" className='arrow top' src={arrow} alt='flecha' />
          <div id="slider-container" className="slider-container">
            {map.companies.map((company, index) => (
              <div key={index} className="companies__slider-image slider-slide" id={index}>
                <Link
                  key={index}
                  to={`${getURLByRouteName("global")}?key=${company.title}`}
                >
                  <img
                    className="home__world-image"
                    src={company.smallLogo}
                    alt={company.title}
                  />
                </Link>
              </div>
            ))}
          </div>
          <img onClick={() => onChangeSlide('bottom')} id="btn-bottom" className='arrow bottom' src={arrow} alt='flecha' />
        </div>
      </div>
      <div className="home__world-select-container">
        <div className="home__world-select">
          <div
            className={`home__world-select-item ${selectView === "operation" ? "active" : ""
              }`}
            onClick={() => setSelectView("operation")}
          >
            <div className="selector red" />
            <span>{texts.operation}</span>
          </div>
          <div
            className={`home__world-select-item ${selectView === "worldwide" ? "active" : ""
              }`}
            onClick={() => setSelectView("worldwide")}
          >
            <div className="selector" />
            <span>{texts.worldwide}</span>
          </div>
        </div>
      </div>
      <MapView selectView={selectView} companies={map.companies} />

      <div className="about-us__title-centered transition">
        <Link
          to={getURLByRouteName("global")}
          className="about-us__download-btn"
        >
          {texts.globalBtn}
        </Link>
      </div>
    </div>
  );
}

export default Companies

const MapView = props => {
  const [isMainMap, setIsMainMap] = useState(true)
    , [active, setActive] = useState('')
    , { selectView, companies } = props

  const onClick = () => {
    setIsMainMap(!isMainMap)
  }

  useEffect(() => {
    setActive('active')
    setTimeout(() => {
      setActive('')
    }, 500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectView])

  return <div className={`home__world-map transition ${active}`}>
    <img onClick={onClick} className='arrow left' src={arrow} alt='flecha' />
    <img id='operation-map' className='transition' src={isMainMap ? mainMap : backMap} alt='mapa del mundo' />
    <img onClick={onClick} className='arrow right' src={arrow} alt='flecha' />
    {
      isMainMap
        ? <><MainFace selectView={selectView} companies={companies} /><ResponsiveView selectView={selectView} companies={companies} countries={countries} /></>
        : <><BackFace selectView={selectView} companies={companies} /><ResponsiveView selectView={selectView} companies={companies} countries={countries} /></>
    }
  </div>
}

const MainFace = props => {
  let { selectView, companies } = props
    , countryItems = countries
      .filter(country => country.main)

  countryItems = selectView === 'operation'
    ? countryItems.filter(country => country.active)
    : countryItems

  const getCoords = () => {
    countryItems
      .filter(country => country.main)
      .forEach(country => getPostitions(country))
  }

  useEffect(() => {
    window.addEventListener('resize', getCoords)
    setTimeout(getCoords, 500)
    return () => {
      window.removeEventListener('resize', getCoords)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectView])

  return <div className='home__world-map-container'>
    {
      countryItems
        .filter(country => country.main)
        .map(country => selectView === 'operation'
          ? <WorldItem companies={companies} country={country} key={country.id} />
          : <WorldItemInactive country={country} key={country.id} />)
    }
  </div>
}

const BackFace = props => {
  let { selectView, companies } = props
    , countryItems = countries
      .filter(country => !country.main)

  countryItems = selectView === 'operation'
    ? countryItems.filter(country => country.active)
    : countryItems.filter(country => !country.active)

  const getCoords = () => {
    countryItems
      .forEach(country => getPostitions(country))
  }

  useEffect(() => {
    window.addEventListener('resize', getCoords)
    setTimeout(getCoords, 500)
    return () => {
      window.removeEventListener('resize', getCoords)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectView])

  return <div className='home__world-map-container'>
    {
      countryItems
        .filter(country => !country.main)
        .map(country => selectView === 'operation'
          ? <WorldItem companies={companies} country={country} key={country.id} />
          : <WorldItemInactive country={country} key={country.id} />)
    }
  </div>
}

const WorldItemInactive = props => {
  let { country } = props

  return <div key={country.id} className={`home__world-map-item  ${country.reverse ? 'reverse' : ''}`} id={country.id}>
    <div>
      <div className={`country-tag ${country.reverse ? 'reverse' : ''}`}>
        <span>{country.name}</span>
        <div className='coord' />
      </div>
    </div>
  </div>
}

const WorldItem = props => {
  const { companies } = props
  const [isHover, setIsHover] = useState(false)
    , slideRef = useRef(null)
    , [currentSlide, setCurrentSlide] = useState(0)

  const zoomInProperties = {
    autoplay: true,
    indicators: false,
    arrows: false,
    scale: 1.4,
    duration: 1000,
  }

  const onChangeSlide = (previous, next) => {
    setCurrentSlide(next)
  }

  let { country } = props

  let companiesList = companies.filter(company => company.countries && company.countries[country.id])

  return <div className={`home__world-map-item active ${isHover ? 'hover' : ''}`}
    id={country.id}
    onMouseEnter={() => {
      setCurrentSlide(0)
      setIsHover(true)
    }}
    onMouseLeave={() => {
      setCurrentSlide(0)
      setIsHover(false)
    }}>
    <div>
      <div className={`country-tag ${country.reverse ? 'reverse' : ''}`}>
        <span>{country.name}</span>
        <div className='coord' />
      </div>
      {
        isHover &&
        <div className='home__world-map-slider'>
          <div className='home__world-map-slider-container'>
            <Fade ref={slideRef} {...zoomInProperties} onChange={onChangeSlide}>
              {
                companiesList.map(company => <div className='home__world-map-slider-item'>
                  <img src={company.smallLogo} alt={company.smallLogo} />
                </div>)
              }
            </Fade>
          </div>
          <div className='operations__slider-bullets-container'>
            {
              companiesList.map((item, index) => <div
                key={index}
                className={`bullet ${currentSlide === index ? 'current' : ''} transition`}
                onClick={() => {
                  setCurrentSlide(index)
                  slideRef.current.goTo(index)
                }}
              />)
            }
          </div>
        </div>
      }
    </div>
  </div>
}
const ResponsiveView = (props) => {
  let { selectView } = props
    , countryItems = countries
  countryItems = selectView === 'operation'
    ? countryItems.filter(country => country.active)
    : countryItems
  return (
    <div className="home__world-select-responsive">
      <ul>
        {countryItems.map((country) => (
          <li key={country.id}>{country.name}</li>
        ))}
      </ul>
    </div>
  );
}